export default function CRICategoryDirective() {
  return {
    template: require('./cri-category.html'),
    scope: {
      criFunctionId: '=',
      criCategory: '=',
      assessmentId: '=',
      isEdit: '=',
      tooltipAppendToSelector: '@',
      form: '=',
    },
    controller: 'CRICategoryController',
    controllerAs: 'criCategoryVM',
    bindToController: true,
    replace: true
  };
}
